module.exports = __webpack_public_path__ + "img/img31.4411c835.svg";